$(document).ready(function(){
    $('br').attr('aria-hidden','true');
    $(".menu-item-has-megamenu > a").removeAttr("href");
    $(".menu-item-has-megamenu > a").attr('role','button');
    $(".menu-item-has-megamenu > a").attr('aria-expanded','false');
    $(".sub-menu.mega-menu-container").hide();
    $('h2, h3, h4, h5, h6').each(function() {
        if (!$.trim($(this).text())) {
            $(this).remove();
        }
    });
    $('.gf_gs-text-heading-2').remove('h1');
    $('.ma-calendar-header').remove('h2');
    $('td sup').append('<span class="visually-hidden">Inches</span>');
    $('.page-numbers.nav-links span.page.current').prepend('<span class="visually-hidden">Current Page </span>');
    $('.page-numbers.nav-links span.page a').each(function() {
        var trimmedTitle = $(this).text().trim();
        $(this).attr('aria-label', 'Page ' + trimmedTitle);
        $(this).reomveAttr('title');
    });
    $('.slideshow.main-slideshow.carousel').removeAttr('tabindex');
    $('.text-with-icons__block-content p a').each(function() {
        var titleText = $(this).attr('title');
        var trimmedTitle = titleText ? titleText.trim() : '';
        $(this).attr('aria-label', 'Learn more About Care Tips' );
        $(this).removeAttr('target', '_blank');
    });
});


// For Drop-Down Menu
$(document).ready(function() {
let last=null;
    $(".menu-item-has-megamenu > a").click(function(e) {
        e.preventDefault();
       last = this;
        $(".menu-item-has-megamenu > a").not(this)
            .attr("aria-expanded", "false")
            .siblings(".sub-menu.mega-menu-container").removeClass("menu-active");
        const isExpanded = $(this).attr("aria-expanded") === "true";
        $(this).attr("aria-expanded", !isExpanded);
        $(this).siblings(".sub-menu.mega-menu-container").toggleClass("menu-active", !isExpanded);
    });
      $(document).on('keydown', function(e) {
        if (e.key === "Escape") {
            $(".menu-item-has-megamenu > a").attr("aria-expanded", "false");
            $(".sub-menu.mega-menu-container").removeClass("menu-active");
        }
    });
    $(document).click(function(event) {
        if (!$(event.target).closest('.menu-item-has-megamenu').length) {
            // Close all menus if the click is outside
            $(".menu-item-has-megamenu > a").attr("aria-expanded", "false");
            $(".sub-menu.mega-menu-container").removeClass("menu-active");
        }
    });
    function closeAllMenus() {
        $(".menu-item-has-megamenu > a").attr("aria-expanded", "false");
        $(".sub-menu.mega-menu-container").removeClass("menu-active");

        if (last) {
            setTimeout(function() {
                last.focus();
            }, 125);
        }
    }
    $(".sub-menu.mega-menu-container").on('focusout', function(e) {
        if (!$(this).has(e.relatedTarget).length) {
            closeAllMenus();
        }
    });
});

// For Heading
$(document).ready(function() {
    setTimeout(function() {
        $("div#rich-text-138922715 [style]").replaceWith(function() {
            return $('<h2>', {
                html: $(this).html(),
                class: $(this).attr('class'),
                style: $(this).attr('style')
            });
        });
    }, 2000);
});

// For Emails Warning
$(document).ready(function() {
    $('a[href="mailto:marketing@margaretoleary.com"], a[href="mailto:shop@margaretoleary.com"],a[href="mailto:info@margaretoleary.com"], a[href="mailto:customercare@margaretoleary.com"], a[href="mailto:millvalley@margaretoleary.com"],a[href="mailto:berkeley@margaretoleary.com"],a[href="mailto:fillmore@margaretoleary.com"],a[href="mailto:paloalto@margaretoleary.com"],a[href="mailto:burlingame@margaretoleary.com"],a[href="mailto:montana@margaretoleary.com"],a[href="mailto:mbeach@margaretoleary.com"],a[href="mailto:portland@margaretoleary.com"],a[href="mailto:uvillage@margaretoleary.com"],a[href="mailto:denver@margaretoleary.com"],a[href="mailto:edina@margaretoleary.com"],a[href="mailto:chicago@margaretoleary.com"],a[href="mailto:boston@margaretoleary.com"],a[href="mailto:denver@margaretoleary.com"],a[href="mailto:web@margaretoleary.com"]' ).each(function() {
        var originalTitle = $(this).text();

           var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;

      // Add "email address" before the trimmedTitle in the aria-label
      $(this).attr('aria-label', 'Email Address: ' + trimmedTitle + ' (open in a new window)');

      $(this).attr('target', '_blank');
      $(this).removeAttr('title');

    });
});

// For Phone Warning
$(document).ready(function() {
    $('a[href="tel:+14153882390"],a[href="tel:+15105408241"],a[href="tel:+14157719982"],a[href="tel:+16506818000"],a[href="tel:+16503449051"],a[href="tel:+13104961800"],a[href="tel:+13103638830"],a[href="tel:+15037073352"],a[href="tel:+12067295934"],a[href="tel:+17204190202"],a[href="tel:+19522089580"],a[href="tel:+13122848455"],a[href="tel:+16175359144"]').each(function() {
        var originalTitle = $(this).text();

        var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;

        // Add "email address" before the trimmedTitle in the aria-label
        $(this).attr('aria-label', 'Phone Number: ' + trimmedTitle + ' (open in a new window)');

        $(this).attr('target', '_blank');
        $(this).removeAttr('title');
    });
  });

// Your Rights warning
$(document).ready(function() {
    $('a[href="https://rakutenadvertising.com/legal-notices/services-privacy-rights-request-form/"]').attr('aria-label', 'Your Rights, this link will open in a new tab')
  });

// external link for title labels
$(document).ready(function() {
    $('a[href="https://www.marincf.org/"],a[href="https://margaretoleary.returnscenter.com/"],a[href="https://docs.google.com/forms/d/e/1FAIpQLSd9fjshxqHulsM3x3IjSdlYqLShsw0NeWyf-aKu9oIBBeDd7A/viewform"]').each(function() {
        var originalTitle = $(this).text();


  var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;

      // Add "email address" before the trimmedTitle in the aria-label
      $(this).attr('aria-label', trimmedTitle + ' (open in a new window)');

      $(this).attr('target', '_blank');
      $(this).removeAttr('title');});
  });

// For Tab Panel
// $(document).ready(function() {
//     $('.tabbed-content--tabs button').on('click keydown', function(e) {
//       if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
//         e.preventDefault();
//         $('.tabbed-content--tabs button').attr('aria-pressed', 'false').removeClass('active');
//         $(this).attr('aria-pressed', 'true').addClass('active');
//       }
//     });
//   });

// drawers aria-hidden toggle
$(document).ready(function() {
        function updateAriaHidden(drawer) {
            if ($(drawer).hasClass('active')) {
                $(drawer).attr('aria-hidden', 'false');
            } else {
                $(drawer).attr('aria-hidden', 'true');
            }
        }
        function classChangeHandler() {
            updateAriaHidden(this);
        }
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === "class") {
                    classChangeHandler.call(mutation.target);
                }
            });
        });
        // Observers for each drawer
        $('.side-panel.product-information-drawer').each(function() {
            observer.observe(this, { attributes: true });
        });

        $('.side-panel.cart-drawer').each(function() {
            observer.observe(this, { attributes: true });
        });

        $('.side-panel.search-drawer').each(function() {
            observer.observe(this, { attributes: true });
        });
        $('.side-panel').each(function() {
            updateAriaHidden(this);
        });
    });

// search drawer focus.
$(document).ready(function() {
  document.querySelector('.side-panel-close.search').addEventListener('click', function() {
    const searchButton = document.querySelector('.thb-secondary-area-item.thb-quick-search');
    if (searchButton) {
        searchButton.focus();
    }
    });
document.addEventListener('keydown', function(event) {
    const searchDrawer = document.querySelector('.side-panel.search-drawer');
    if (event.key === 'Escape' && searchDrawer.classList.contains('active')) {
        const searchButton = document.querySelector('.thb-secondary-area-item.thb-quick-search');
        if (searchButton) {
            searchButton.focus();
        }
    }
    });
});

// filters focus management
$(document).ready(function() {
    // filter drawer focus.
    document.querySelector('.side-panel-close.filter').addEventListener('click', function() {
        const filterButton = document.querySelector('#Facets-Toggle');
        if (filterButton) {
            filterButton.focus();
        }
    });
    document.addEventListener('keydown', function(event) {
        const filterDrawer = document.querySelector('#Facet-Drawer');
        if (event.key === 'Escape' && filterDrawer.classList.contains('active')) {
            const filterButton = document.querySelector('#Facets-Toggle');
            if (filterButton) {
                filterButton.focus();
            }
        }
    });
document.querySelector('.button.mobile-filters-apply').addEventListener('click', function() {
    const filterButton = document.querySelector('#Facets-Toggle');
    if (filterButton) {
        filterButton.focus();
    }
    });
});

// product info side panel expand/collaps
$(document).ready(function() {
    $('.side-panel-links--link').on('click', function() {
        let isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !isExpanded);
        $('.side-panel-links--link').not(this).attr('aria-expanded', 'false');
    });
    $('.side-panel-close').on('click', function() {
        $('.side-panel-links--link').attr('aria-expanded', 'false');
    });
    $(document).on('keydown', function(event) {
        if (event.key === 'Escape') {
            $('.side-panel-links--link').attr('aria-expanded', 'false');
        }
    });
});

// filter collaps/expand
$(document).ready(function() {
    $('.facets-toggle').on('click', function() {
        let isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !isExpanded);
        $('.facets-toggle').not(this).attr('aria-expanded', 'false');
    });
    $('.side-panel-close').on('click', function() {
        $('.facets-toggle').attr('aria-expanded', 'false');
    });
    $(document).on('keydown', function(event) {
        if (event.key === 'Escape') {
            $('.facets-toggle').attr('aria-expanded', 'false');
        }
    });
});

// product info tabs
$(document).ready(function() {
    $('.side-panel-content--tabs button').on('click keydown', function(e) {
      if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $('.side-panel-content--tabs button').attr('aria-pressed', 'false').removeClass('active');
        $(this).attr('aria-pressed', 'true').addClass('active');
      }
    });
  });

// redirection of add to cart to cart page
// $('#AddToCart').on('click', function(event) {
//     setTimeout(function() {
//         window.location.href = "https://www.margaretoleary.com/cart";
//     }, 1500);
// });

// pagination query
$(document).ready(function() {
    $('.page-numbers.nav-links span.page a').each(function() {
        var href = $(this).attr('href');
        if (href && !$(this).attr('aria-label')) {
            var pageMatch = href.match(/page=(\d+)/);
            if (pageMatch) {
                var pageNumber = pageMatch[1];
                $(this).attr('aria-label', 'Page ' + pageNumber);
            }
        }
    });
});
// Function to be executed after the timer
function timerCompleted() {
    console.log("Timer completed!");
}
setTimeout(timerCompleted, 1000);